import { Box, Grid, AccordionDetails as MUIAccordionDetails, Stack } from "@mui/material";
import ArrowUp from "assets/ArrowUp.svg";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { getFilteredAssignees, getUserHltId } from "utils/CommonFunctions";
import ActionCard from "../../ActionCard";

interface Props {
  section: any;
  index: number;
  planType: string;
  planId: number;
  handleAccordianOpen: any;
  open?: boolean;
  multiCardSelect: boolean;
}

function AccordionDetails(props: Props) {
  const { section, planType, planId, open, handleAccordianOpen, multiCardSelect } = props;
  const colorCode = open ? tokens.Border.General.LightColor : tokens.Border.General.Secondary;
  const allAssignees: any = useAppSelector((state) => state.myPlanDetails.ad);
  const isActionHighlight = useAppSelector((state: any) => state.myplans?.MyPlans.isActionHighlight);

  const { isMobileScreen }: any = useContext(ThemeContext);

  return (
    <>
      <MUIAccordionDetails sx={{ p: 0 }} onClick={handleAccordianOpen}>
        <div style={{ width: "100%", cursor: "pointer" }}>
          <Grid
            container
            padding={isMobileScreen ? 0 : 2}
            borderLeft={isMobileScreen ? "unset" : `2px dashed ${colorCode}`}
            marginLeft={isMobileScreen ? 0 : "16px"}
            marginTop={isMobileScreen ? 0 : "8px"}
          >
            {!isMobileScreen && (
              <Grid
                item
                xs={12}
                sm={3}
                sx={{
                  paddingRight: "16px",
                  marginLeft: "28px"
                }}
              >
                <Typography>{section?.summary}</Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={8} display="flex" flexDirection="row" flexWrap="wrap" gap={"12px"} marginTop="-60px">
              {section?.cards?.length ? (
                section?.cards?.map((element: any) => {
                  const isAssigned = element?.assignee?.includes(getUserHltId()) ?? false;
                  return (
                    <ActionCard
                      key={element.id}
                      item={element}
                      planType={planType}
                      sectionId={section?.id}
                      planId={planId}
                      multiCardSelect={multiCardSelect}
                      allAssignees={getFilteredAssignees(element.assignee, allAssignees)}
                      isDisabled={!isAssigned && isActionHighlight}
                    />
                  );
                })
              ) : (
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    width: "100%",
                    padding: "32px 48px",
                    borderRadius: "12px",
                    height: "194px",
                    backgroundColor: colors.Neutral.Neutral100
                  }}
                >
                  <Typography variant="h5" showBold color={colors.Neutral.Neutral400}>
                    No actions yet.
                  </Typography>
                </Stack>
              )}
            </Grid>
          </Grid>
          {open && (
            <Grid
              sx={{ marginTop: "16px", marginRight: "6px" }}
              item
              xs={12}
              display="flex"
              flexDirection="row-reverse"
            >
              <img src={ArrowUp} alt="Arrow up" width="20px" height="20px" />
            </Grid>
          )}
          {!isMobileScreen && (
            <Box
              sx={{
                borderLeft: `2px dashed ${colorCode}`,
                margin: "-34px 16px -20px",
                height: "60px"
              }}
            />
          )}
        </div>
      </MUIAccordionDetails>
    </>
  );
}

export default AccordionDetails;
